import development from "../../assets/development.svg";
import { type AppResponse } from "../../state/api.types";
import { useDocumentTitle } from "../../utilities/useDocumentTitle";
import { KeysCard } from "./KeysCard";
import { SandboxCard } from "./SandboxCard";
import { StandaloneCard } from "./StandaloneCard";
import { WebhooksCard } from "./WebhooksCard";
import { WebhookSlideout } from "./WebhookSlideout";

type DevelopmentPageProps = {
  app: AppResponse;
};

export const DevelopmentPage = (props: DevelopmentPageProps) => {
  useDocumentTitle("Development");

  return (
    <WebhookSlideout app={props.app}>
      <div className="p-4xl">
        <div className="mb-7xl flex items-center gap-xl">
          <img
            src={development}
            alt="development"
            className="h-12 w-12 object-contain"
          />
          <div className="text-display-sm font-semibold">Development</div>
        </div>
        <div className="mx-auto w-full max-w-xl space-y-4xl">
          <SandboxCard app={props.app} />
          <KeysCard app={props.app} />
          <WebhooksCard app={props.app} />
          <StandaloneCard app={props.app} />
        </div>
      </div>
    </WebhookSlideout>
  );
};
